import { render, staticRenderFns } from "./DictManage.vue?vue&type=template&id=0d3eb1f6&scoped=true"
import script from "./DictManage.vue?vue&type=script&lang=js"
export * from "./DictManage.vue?vue&type=script&lang=js"
import style0 from "./DictManage.vue?vue&type=style&index=0&id=0d3eb1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3eb1f6",
  null
  
)

export default component.exports